<template>
  <div class="py-10 px-4 sm:px-6 lg:px-8 overflow-hidden">
    <ParagraphGallerySlider :slides="images ?? null">
      <template #item="media">
        <div
          class="rounded-[4px] sm:rounded-[8px] overflow-hidden w-full max-w-full"
        >
          <MediaImage
            v-bind="media"
            :image-style="imageStyle"
            class="w-full h-auto object-cover"
          />
        </div>
      </template>
    </ParagraphGallerySlider>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphGalleryFragment } from '#graphql-operations'

defineProps<{
  images?: ParagraphGalleryFragment['images']
}>()

defineBlokkli({
  bundle: 'gallery',
})

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 5 / 4,
  sizes: {
    xl: 912,
  },
})
</script>
